import {inject} from '@angular/core';
import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {AlertService} from '@ratespecial/core';
import {HttpErrorService} from '../../http/http-error.service';


/**
 * If any ajax call results in an error, we handle here to avoid duplicate code in the various components
 * and services that make requests.  422 Errors are not caught to allow Form Validation Errors to be handled
 * by the component directly
 */
export const serverErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const alertService = inject(AlertService);
  const httpErrorService = inject(HttpErrorService);

  return next(req).pipe(
    tap({
      next: () => {
      },
      error: err => {
        //Allow 422 pass through to the component's form validation handler because use cases vary for forms
        // and modal windows that need a different error presentation than the typical alert logic.
        //Allow 401 to be handled by auth interceptor
        if (err instanceof HttpErrorResponse && err.status !== 422
          && err instanceof HttpErrorResponse && err.status !== 401
        ) {
          httpErrorService.handleError(err);

        } else if (err.error instanceof Error) {
          alertService.error("A Network Error Occurred");
        }
      }
    })
  );
};
